import * as CoreRoutes from './core.routes';

import { DateLocaleService } from './services/dateLocale.service';
import { TranslationHelperService } from './services/translation-helper.service';
import { ResponseInterceptor } from './services/ResponseInterceptor.service';
import { StatusClass } from './filters/statusClass.filter';
import { UpperCaseFirstLetter } from './filters/upperCaseFirstLetter.filter';
import { StatusIcon } from './filters/statusIcon.filter';
import { DateFromString } from './filters/dateFromString.filter';
import { JourneyLocation } from './filters/journeyLocation.filter';
import { RequestInterceptor } from './services/requestInterceptor.service';
import { NgEnter } from './directives/ngEnter.directive';
import { KeycloakService } from '../services/keycloak.service';

export const initialise = (keycloakInstanceObject) => {

  // ServicesModule.initialise();

  /**
   * This module defines the core application behaviour such as routing and translation services.
   */
  angular
    .module('app.core', [
      'actora.services',
      'ngAnimate',
      'ngSanitize',
      'ui.bootstrap',
      'scDateTime',
      'schemaForm',
      'ui.validate',
      'ui.router.upgrade',
      'ngStorage',
      'ngMaterial',
      'pascalprecht.translate',
      'ngMessages',
      'ngCookies',
      'LocalStorageModule',
      'ng-currency'
    ]).run(['translationHelperService', '$rootScope', 'dateLocaleService', '$mdDialog', '$transitions', '$state', (
      translationHelperService: TranslationHelperService,
      $rootScope: ng.IRootScopeService,
      dateLocaleService: DateLocaleService,
      $mdDialog: ng.material.IDialogService,
      $transitions,
      $state: ng.ui.IStateService) => {
        let onTranslationChanged;
        const languageKey = 'en';
        translationHelperService.initialiseAppTranslations(languageKey, languageKey);

        onTranslationChanged = $rootScope.$on('$translateChangeSuccess', () => {
          dateLocaleService.configureDateLocaleProvider();
        });

        $transitions.onStart({}, () => {
          (<any>$rootScope).showSpinner = true;
          $mdDialog.cancel();
        });

        $transitions.onSuccess({}, (toState, fromState, params, somethingElse) => {
          (<any>$rootScope).showSpinner = false;

          if(toState.name === 'home') {
            $state.go('customers');
          }
        });

        $transitions.onError({}, () => {
          (<any>$rootScope).showSpinner = false;
        });

        $rootScope.$on('$destroy', () => {
          onTranslationChanged();
        });
      }]).config(['$translateProvider', ($translateProvider) => {
        $translateProvider.useStaticFilesLoader({
          prefix: 'assets/locale/',
          suffix: '.json'
        });
        return $translateProvider.useSanitizeValueStrategy('escapeParameters');
      }]).config(['$httpProvider', '$mdThemingProvider', ($httpProvider, $mdThemingProvider) => {
        $httpProvider.interceptors.push('responseInterceptor');
        $httpProvider.interceptors.push('requestInterceptor');
        if (!$httpProvider.defaults.headers.get) {
          $httpProvider.defaults.headers.get = {};
        }
        $httpProvider.defaults.headers.get['If-Modified-Since'] = '0';

        $mdThemingProvider.definePalette('actoraTheme', {
          50: 'E5F0F8',
          100: 'BED9ED',
          200: '92C0E2',
          300: '66A7D6',
          400: '4694CD',
          500: '2581C4',
          600: '2179BE',
          700: '1B6EB6',
          800: '1664AF',
          900: '0D51A2',
          A100: 'D0E4FF',
          A200: '9DC6FF',
          A400: '6AA8FF',
          A700: '5199FF',
          contrastDefaultColor: 'light',
          contrastDarkColors: ['50', '100', '200', '300', '400', 'A100'],
          contrastLightColors: undefined
        });

        return $mdThemingProvider.theme('default')
          .primaryPalette('actoraTheme');
      }])
    .config(['$qProvider', ($qProvider) => {
      $qProvider.errorOnUnhandledRejections(false);
    }])
    .filter('statusClass', () => { return StatusClass.OnFilterApplied; })
    .filter('statusIcon', () => { return StatusIcon.OnFilterApplied; })
    .filter('dateFromString', () => { return DateFromString.OnFilterApplied; })
    .filter('upperCaseFirstLetter', () => { return UpperCaseFirstLetter.OnFilterApplied; })
    .filter('journeyLocation', () => { return JourneyLocation.OnFilterApplied; })
    .factory('dateLocaleService', ['$mdDateLocale', '$translate', ($mdDateLocale, $translate) => { return new DateLocaleService($mdDateLocale, $translate); }])
    .factory('translationHelperService', ['$translate', '$q', '$cookies', ($translate, $q, $cookies) => new TranslationHelperService($translate, $q, $cookies)])
    .factory('responseInterceptor', ['$q', '$rootScope', '$injector', 'keycloakService', ($q: ng.IQService, $rootScope: ng.IRootScopeService, $injector: ng.auto.IInjectorService, keycloakService: KeycloakService) => {
      return new ResponseInterceptor($q, $rootScope, $injector, keycloakService);
    }])
    .factory('requestInterceptor', ['$q', 'keycloakService', ($q, keycloakService: KeycloakService) => { return new RequestInterceptor($q, keycloakService); }])
    .value('keycloakInstance', keycloakInstanceObject)
    .directive('ngEnter', [() => { return new NgEnter(); }]);

  CoreRoutes.initialise();
};